import React, { Component } from 'react'
import Video from './Video/Video'
import About from './About/About'
import Event from './Event/Event'
import Speaker from './Speaker/Speaker'
import News from './News/News'
import Banner from './Banner/Banner'
import { withRouter } from '../../utils/with-router'

class Home extends Component {
    render(){
        return (
            // <div class="home_container">
                <div>
                    <Banner />
                    {/* <Video /> */}
                    <About />
                    <Event />
                    <Speaker />
                    <News />
                </div>
            // </div>
        )
    }

}

export default withRouter(Home);

